module.exports = __webpack_public_path__ + "img/Salt-City.d8949e6b.png";